<template>
    <div style="width: 100%; margin-bottom: 1rem;">
        <div style="margin-top: 1.5em"></div>
        <h1 class="text-center gris" style="font-family: var(--titulos); color: var(--title); font-size: 2rem;">
            Regalo
        </h1>
        <div style="margin-top: 1.5em"></div>
        <img src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Delgado%20Calles%2FRegalo.svg?alt=media&token=c049d26c-9417-41fe-9cfb-ec22a03e8b41"
            style="display: block; margin: 0 auto; width: 5rem" />
        <div style="margin-top: 1em"></div>
        <p class="text-center" id="text" style="width: 90%; margin: 0 auto;">
            ¡Tu amor y apoyo significan el mundo para nosotros!
        </p>
        <p class="text-center" id="text" style="width: 90%; margin: 0 auto;">
            Agradecemos inmensamente tus muestras 
            de cariño en regalo de sobre. 
        </p>
    </div>
</template>


<script>
import axios from 'axios';

export default {
    name: 'GitfTable',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            Links: [],
            Gitfs: [],
            GitfsExt: [],
            Envelope: 0,
            diferencial: this.$route.query.id,
        };
    },
    methods: {
        getGift() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}gitTable/GetGiftTable/${this.Code}` : `${process.env.VUE_APP_API_PRO}gitTable/GetGiftTable/${this.Code}`;
            axios.get(url)
                .then((response) => {
                    const gift = Array.from(response.data);
                    gift.map((res) => {
                        let data = {
                            Gift: res.LinkProducto,
                        }
                        let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}gitTable/GetGiftUrl` : `${process.env.VUE_APP_API_PRO}gitTable/GetGiftUrl`;
                        axios.post(url, data)
                            .then((result) => {
                                this.Links.push(data.Gift);
                                this.Gitfs.push(result.data)
                            }).catch((err) => {
                                console.error(err.message);
                            });
                    });
                })
                .catch(err => console.error(err));
        },
        getGiftExt() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}gitTable/GetGiftTableExt/${this.Code}` : `${process.env.VUE_APP_API_PRO}gitTable/GetGiftTableExt/${this.Code}`;
            axios.get(url)
                .then((response) => this.GitfsExt = response.data)
                .catch(err => console.error(err));
        },
        getEnvelopeGift() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}gitTable/GetEnvelopeGift/${this.Code}` : `${process.env.VUE_APP_API_PRO}gitTable/GetEnvelopeGift/${this.Code}`;
            axios.get(url)
                .then((response) => this.Envelope = response.data.RegaloSobre)
                .catch(err => console.error(err));
        },

        goToProduct(link) {
            console.log(link);
            window.open(link, '_blank');
        }

    },
    created() {
        this.getGift();
        this.getGiftExt();
        this.getEnvelopeGift();
    },
}
</script>

<style scoped>
#giftTable {
    display: grid;
    gap: 1rem;
    grid-auto-rows: 22rem;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 25rem), 1fr));
    place-items: center;
    margin-bottom: 1rem;
    color: var(--text);
}

.gift {
    display: grid;
    place-items: center;
}

button {
    background-color: rgb(187, 148, 106);
    border-radius: 0.5rem;
    height: 2rem;
    z-index: 2;
}

#giftTableExt {
    display: grid;
    gap: 1rem;
    grid-auto-rows: 10rem;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 25rem), 1fr));
    place-items: center;
    margin-bottom: 1rem;
    color: #6b8181;
}

.imgs {
    width: 55%;
    margin: 0 auto;
    display: block;
}

.logo:hover {
    width: 55%;
}

#Envelope {
    display: grid;
    place-items: center;
    margin-bottom: 1rem;
    color: #6b8181;
}

#text {
    margin-left: 30rem;
    margin-right: 30rem;
}

#cartel {
    width: 30%;
    margin: auto;
    display: block;
}

@media (max-width: 768px) {
    #text {
        margin-left: 0;
        margin-right: 0;
    }

    #cartel {
        width: 100%;
    }
}
</style>